import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Table, Tag, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetAgreementResponsesByAgreementCampaignIDRequest } from "../../../constants/apiRequestResponse";
import { AgreementCampaign, AgreementResponse, AgreementResponseStatus } from "../../../constants/types";
import { getAgreementCampaigns, getAgreementResponsesByAgreementCampaignID } from "../../../services/api";
import { getQueryParam, parseTime } from "../../../util";

export default function AgreementTab() {
  const [isLoading, setIsLoading] = useState(false);
  const [ageementCampaigns, setAgreementCampaigns] = useState<
    AgreementCampaign[]
  >([]);
  const [isAgreementResponsesLoadingByAgreementId, setIsAgreementResponsesLoadingByAgreementId] =
    useState<{ [key: string]: boolean }>();
  const [agreementResponsesByAgreementId, setAgreementResponsesByAgreementId] = useState<{
    [key: string]: AgreementResponse[];
  }>();
  const agreementId = getQueryParam("agreementId")


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Progress",
      dataIndex: "_progress",
      render: (_progress) => {
        if (_progress === 0) {
          return <Tag>{_progress} %</Tag>;
        } else if (_progress < 100) {
          return <Tag color="yellow">{_progress} %</Tag>;
        }
        return <Tag color="green">{_progress} %</Tag>;
      },
    },
    {
      title: "Terms and condition",
      dataIndex: "tncFileLink",
      render: (tncFileLink) => <a href={tncFileLink}>Link</a>,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (time) => parseTime(time),
    },
  ];

  useEffect(() => {
    getData();
  }, [agreementId]);

  const getData = () => {
    setIsLoading(true);
    getAgreementCampaigns()
      .then((res) => {
        if (!res.success) throw new Error(res.message);
        setAgreementCampaigns(res.agreementCampaigns);
      })
      .catch((err) => {
        message.error(err.toString());
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <Typography.Title level={4}>Agreement Campaigns</Typography.Title>
        <Link to="/agreement/create">
          <Button
            data-testid="create-agreement-campaign-btn"
            type="primary" icon={<PlusOutlined />}>
            Create
          </Button>
        </Link>
      </div>

      <Table
        tableLayout={"auto"}
        loading={isLoading}
        rowKey={"_id"}
        columns={columns}
        scroll={{
          x: columns.length * 150,
        }}
        dataSource={ageementCampaigns}
        expandable={{
          onExpand: (expanded: boolean, agreementCampaign: AgreementCampaign) => {
            if (!expanded) return null

            setIsAgreementResponsesLoadingByAgreementId(prev => ({
              ...isAgreementResponsesLoadingByAgreementId,
              [agreementCampaign._id]: true,
            }));

            const req2: GetAgreementResponsesByAgreementCampaignIDRequest = {
              agreementCampaignId: agreementCampaign._id,
            };

            getAgreementResponsesByAgreementCampaignID(req2)
              .then((res) => {
                if (!res.success) throw new Error(res.message);
                setAgreementResponsesByAgreementId(prev => ({
                  ...prev,
                  [agreementCampaign._id]: res.agreementResponses || [],
                }));
              })
              .catch((err) => {
                message.error(err.toString());
              })
              .finally(() => {
                setIsAgreementResponsesLoadingByAgreementId(prev => ({
                  ...prev,
                  [agreementCampaign._id]: false,
                }));
              });
          },
          expandedRowRender: (agreementCampaign: AgreementCampaign) => {
            const agreementResponses = agreementResponsesByAgreementId
              ? agreementResponsesByAgreementId[agreementCampaign._id]
              : []

            const columns = [
              {
                title: "User",
                dataIndex: "companyUserName",
              },
              {
                title: "Company",
                dataIndex: "companyName",
              },
              {
                title: "Status",
                dataIndex: "status",
                render: (status) => {
                  if (status === AgreementResponseStatus.ACCEPTED) {
                    return <Tag color="green">{status}</Tag>;
                  }
                  return <Tag>{status}</Tag>;
                },
              },
              {
                title: "Accepted At",
                dataIndex: "acceptedAt",
                render: (time) => parseTime(time),
              },
            ];

            return (
              <Card style={{ flex: 4 }}>
                <Typography.Title level={5}>Responses</Typography.Title>
                <Table
                  loading={isAgreementResponsesLoadingByAgreementId ? isAgreementResponsesLoadingByAgreementId[agreementCampaign._id] : false}
                  rowKey={"_id"}
                  columns={columns}
                  dataSource={agreementResponses}
                />
              </Card>
            )
          },
        }}
      />
    </div>
  );
}
